export default {
  getVeiculos(state) {
    return state.veiculos
  }
}
